import FeatureParam from 'interfaces/featureParams';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getFeatureParams = () => {
  return apiRequestHandlerPromise<FeatureParam[]>({
    url: `feature_params`,
    method: 'GET',
  });
};
